import API from "../api/api";
import { User, NewUser } from "models/User";

/**
 * UserService
 * -----------
 * Distributor-team CRUD against the /distributor-dashboard/users routes.
 * Distributor scope is inferred by the BE from the scoped JWT — no
 * distributorId in URL or payload. User IDs are GUID strings.
 *
 * NOTE: the update endpoint does NOT accept email — it can only change
 * role, firstName, lastName.
 */

export interface UpdateUserPayload {
  newRole: User["role"];
  firstName?: string;
  lastName?: string;
}

export class UserService {
  async getUsers(): Promise<User[]> {
    const response = await API.get(`/distributor-dashboard/users`);
    return response.data?.users ?? [];
  }

  async getUserById(userId: string): Promise<User> {
    const response = await API.get(`/distributor-dashboard/users/${userId}`);
    return response.data;
  }

  async createUser(payload: NewUser): Promise<User> {
    const response = await API.post(`/distributor-dashboard/users`, payload);
    return response.data;
  }

  async updateUser(userId: string, payload: UpdateUserPayload): Promise<User> {
    const response = await API.put(
      `/distributor-dashboard/users/${userId}/role`,
      payload
    );
    return response.data;
  }

  async deleteUser(userId: string): Promise<void> {
    await API.delete(`/distributor-dashboard/users/${userId}`);
  }
}
